import _ from "lodash";
import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import { connect } from "react-redux";
import classes from "./EventModal.scss";
import { compose, graphql } from "lib/apolloClient";
import { useApolloClient } from "@apollo/client";
import EventBody from "./components/EventBody";
import EventHeader from "./components/EventHeader";
import EventFooter from "./components/EventFooter";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { deleteAssignment } from "ClassRoom/modules/ClassRoomModule";
import EditOrCreateEvent from "MyCalendar/components/EditOrCreateEvent";
import ActionForSelectModal from "MyCalendar/components/ActionForSelectModal";
import {
  deletePlatformCalendarEvent,
  updatePlatformCalendarEventBasicDetails,
  quickUpdateAssignmentScheduleAndDueTime,
  isMasterCalendarV1Enabled,
  updateEventModalV2,
} from "MyCalendar/modules/MyCalendarModule";
import {
  getCalendarEventDetailsEnhancer,
  getCalendarEventAssociatedEntitiesEnhancer,
} from "MyCalendar/modules/Enhancer";
import withLoader from "UIComponents/GqlWithLoader";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import I18nHOC from "UIComponents/I18nHOC";
import {
  getStartEndTimeText,
  getEventMetadata,
  getCalendarEventsViewSettingValue,
  isViewOnlyTagMemoize,
  isVideoMeeting as getIsVideoMeeting,
  removeDemoCoursesMemoized,
  getCourseFiltersMemoized,
  getCourseGradeFiltersMemoized,
  isCalendarEventAssessmentEnabled,
  getRefetchFunctionForQuery,
  isStaffAdminForSchoolCalendarByContext,
} from "MyCalendar/modules/Utils";
import {
  quickUpdateRevampedVideoMeeting,
  editVideoMeeting,
} from "MyCalendar/modules/MyCalendarModule/MyCalendarThunks";
import EventModalLoader from "./components/EventModalLoader";
import EventAssignmentLoader from "./components/EventAssignmentLoader";
import EventUpdateConfirmationModal from "MyCalendar/components/EventModalV2/components/EventUpdateConfirmationModal";
import {
  isNewVideoMeetingUIFeatureEnabled,
  isVideoMeetingAdminEditEnabled,
  TYPENAME_MAPPING,
  ENTITY_TYPE_MAPPING,
} from "MyCalendar/components/EventModalV2/modules/Utils";
import { getShouldShowCourseDisplayName } from "LearningCourses/modules/Utils";

import { GetMeetingJoinURL, formatDate, isUserTypeStaff } from "Utils";
import { goToRelativeRoute, openLinkInNewTab } from "modules/Services";
import { goToPlatformHomeChildRoute } from "modules/NavigationModule";
import {
  getCurriculumProgramFreeStatus,
  getIsCurrentAcademicYear,
} from "Platform/modules/PlatformModule";
import {
  getDefaultStudentNameOrderPreference,
  getIsParent,
  getAcademicYearEndDate,
  getAcademicYearStartDate,
  getOrganizationId,
  getChildId,
} from "modules/CommonSelectors";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import { getCurrentCurriculumProgramType } from "MyCalendar/modules/Selector";
import { CACHE_AND_NETWORK, STUDENT_USER } from "Constants/stringConstants";
import { DATE_TIME_CONSTANTS } from "Constants/dateTimeConstants";
import { Dialog, DSProvider } from "@toddle-edu/ds-web";
import { getFormattedUserName } from "Utils/GetFormattedUserName";
import { getIsGradingPeriodUnlocked } from "GradingSetup/modules/Utils";
import ACLStore from "lib/aclStore";
import { getFilteredCoursesBasedOnViewOrManagePermission } from "ClassRoom/modules/utils";
import {
  ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR,
  ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION,
} from "Constants/permissionConstants";
import {
  getCourseCalendarDetailsQuery,
  getCalendarEventsDataQuery,
  getCalendarEventsParticipantDataQuery,
} from "MyCalendar/modules/MyCalendarQuery";
import {
  getIsCalendarAssignmentAssignFlowRevampEnabled,
  validateAssignmentDateSequence,
} from "./modules/utils";
import { useAssessmentTags, useIsCalendarInUserScope } from "../../hooks";
import { getIsAdminByRole } from "lib/staffPermissionUtils";
import {
  getSelectedSchoolDetailsForCalendar,
  getTransformedVideoMeetingDataFromQuery,
  getSelectedAcademicYearIdForSchool,
  getSelectedAcademicYearForSchool,
} from "../../modules/Utils";

const getAssignedUsers = ({
  itemType,
  users,
  defaultStudentNameOrderPreference,
}) => {
  switch (itemType) {
    case "ASSIGNMENT": {
      return _.reduce(
        users,
        (result, studentObj) => {
          const id = _.get(studentObj, "student.id", null);
          const profileImage = _.get(studentObj, "student.profileImage", null);

          const name = getFormattedUserName({
            user: _.get(studentObj, "student", {}),
            type: "student",
            defaultStudentNameOrderPreference,
          });

          // might have to revisit when we have multiple submissions
          const submission = _.get(studentObj, "submission");
          const statusV2 = _.get(studentObj, "submission.statusV2");
          const submittedAt = _.get(studentObj, "submission.submittedAt");
          const lockingState = _.get(studentObj, "lockingState.state");
          const alertTypes = _.get(studentObj, "student.alertTypes", []);

          result.push({
            id,
            profileImage,
            name,
            submission,
            statusV2,
            submittedAt,
            lockingState,
            alertTypes,
          });
          return result;
        },
        []
      );
    }
    case "CALENDAR_EVENT_ITEM": {
      return _.reduce(
        users,
        (result, studentObj) => {
          const id = _.get(studentObj, "id", null);
          const profileImage = _.get(studentObj, "profileImage", null);
          const name = getFormattedUserName({
            user: studentObj,
            type: "student",
            defaultStudentNameOrderPreference,
          });
          const alertTypes = _.get(studentObj, "alertTypes", []);
          result.push({ id, profileImage, name, alertTypes });
          return result;
        },
        []
      );
    }
  }
};

const getNormalizedEventDetails = ({
  eventData,
  userId,
  userType,
  defaultStudentNameOrderPreference,
}) => {
  let meetingLink = "";
  let meetingCode = "";
  let meetingPasscode = "";
  let assignedUsers = [];
  let courseId = null;

  const {
    id,
    startTime,
    endTime,
    calendars,
    itemType,
    item,
  } = _.pick(eventData, [
    "id",
    "startTime",
    "endTime",
    "calendars",
    "itemType",
    "item",
  ]);

  const {
    content,
    contentType,
    assignedStudents,
    createdBy,
    users,
    repeatEventSettings,
    counts,
    start: recurrenceStart,
    metadata,
    associatedEntities,
  } = _.pick(item, [
    "content",
    "contentType",
    "assignedStudents",
    "createdBy",
    "users",
    "repeatEventSettings",
    "counts",
    "start",
    "metadata",
    "associatedEntities",
  ]);

  switch (itemType) {
    case "ASSIGNMENT": {
      meetingLink = GetMeetingJoinURL({
        meeting: _.get(content, "meeting", null),
        userId,
      });
      assignedUsers = getAssignedUsers({
        itemType,
        users: assignedStudents,
        defaultStudentNameOrderPreference,
      });
      courseId = _.get(
        _.find(calendars, { parentType: "COURSE" }),
        "parent.id",
        null
      );

      break;
    }
    case "CALENDAR_EVENT_ITEM": {
      meetingLink = GetMeetingJoinURL({
        meeting: _.get(item, "meeting", null),
        userId,
      });
      meetingCode = _.get(item, "meeting.urls.meetingCode", "");
      meetingPasscode = _.get(item, "meeting.urls.passcode", "");
      assignedUsers = getAssignedUsers({
        itemType,
        users,
        defaultStudentNameOrderPreference,
      });
      break;
    }
  }
  const eventCreatorName = getFormattedUserName({
    user: createdBy,
    type: "staff",
  });

  const publishedTime = getEventTimeText({
    startTime,
    endTime,
    showOnlyEndTime: itemType === "ASSIGNMENT",
    showStartEndTime:
      userType !== "staff" && itemType !== MY_CALENDAR_CONSTANTS.ASSIGNMENT,
  });

  const submissionDeadlineTime = getEventTimeText({
    startTime: _.get(item, "publishedAt"),
    endTime,
    showOnlyEndTime: false,
    showStartEndTime:
      userType !== "staff" && itemType !== MY_CALENDAR_CONSTANTS.ASSIGNMENT,
  });

  const currentStudentAssignment = _.find(assignedStudents, {
    student: { id: userId },
  });

  const currentStudentAssignmentId = _.get(currentStudentAssignment, "id");

  const typeName = _.get(associatedEntities, "0.__typename", "");
  const entityType = TYPENAME_MAPPING[typeName] || "USER";

  const entityIds =
    entityType === "USER"
      ? _.map(users, "id")
      : _.map(associatedEntities, "id");

  return {
    id,
    item,
    itemType,
    courseId,
    publishedTime,
    submissionDeadlineTime,
    scheduleDate: moment(startTime).format("YYYY-MM-DD"),
    scheduleStartTime: moment(startTime).format("hh:mm a"),
    scheduleEndTime: moment(endTime).format("hh:mm a"),
    meetingLink,
    meetingType: _.get(item, "meeting.type", ""),
    meetingCode,
    meetingPasscode,
    startTime,
    endTime,
    recurrenceStart,
    metadata,
    createdBy: {
      id: _.get(createdBy, "id", null),
      name: _.get(createdBy, "id", null) === userId ? "You" : eventCreatorName,
      profileImage: _.get(createdBy, "profileImage", null),
      eventCreatorName: eventCreatorName,
    },
    calendarWiseAssignedUsers: getCalendarWiseAssignedUsers({
      calendars,
      assignedUsers,
    }),
    contentType,
    assignmentId: _.get(item, "id"),
    repeatEventSettings,
    calendars,
    state: _.get(item, "state.state"),
    publishedAt: _.get(item, "publishedAt"),
    calendarAssignmentEndAt: endTime,
    stringDeadline: _.get(item, "stringDeadline"),
    visibility: _.get(item, "visibility"),
    closeSubmissionDate: _.get(item, "closeSubmissionDate"),
    submissionsSummaryCounts: counts,
    isStudentSubmissionEnabled: _.get(item, "isStudentSubmissionEnable"),
    isPrivate: _.get(item, "isPrivate"),
    currentStudentAssignmentId,
    isAssessmentLocked: _.get(content, "lockingInfo.isLocked", false),
    eventAssociatedEntities: associatedEntities,
    eventReminders: _.get(item, "eventReminders", []),
    meeting: _.get(item, "meeting", null),
    entityType,
    entityIds,
    users,
  };
};

const getEventTimeText = ({
  startTime,
  endTime,
  showOnlyEndTime,
  showStartEndTime,
}) => {
  const today = formatDate({
    date: startTime,
    format: DATE_TIME_CONSTANTS.ddd_MMM_DD,
  });

  let timeDuration = showOnlyEndTime
    ? formatDate({ date: endTime, format: "hh:mm a" })
    : formatDate({ date: startTime, format: "hh:mm a" });

  if (showStartEndTime) {
    timeDuration = getStartEndTimeText({
      startDate: startTime,
      endDate: endTime,
    });
  }

  return `${today} | ${timeDuration}`;
};

const getCalendarWiseAssignedUsers = ({ calendars, assignedUsers }) => {
  return _.reduce(
    calendars,
    (result, calendarItem) => {
      const parent = _.get(calendarItem, "parent");
      const parentType = _.get(calendarItem, "parentType");

      if (parentType === "COURSE") {
        const shouldShowCourseDisplayName = getShouldShowCourseDisplayName();
        const allStudents = _.get(parent, "allStudents.edges");
        const assignedUsersFromThisCalendar = _.intersectionWith(
          assignedUsers,
          allStudents,
          (val1, val2) => _.get(val1, "id") === _.get(val2, "node.id")
        );
        const calendarTitle = shouldShowCourseDisplayName
          ? _.get(parent, "learningCourse[0].academicCourse.label") ||
            _.get(parent, "learningCourse[0].title") ||
            _.get(parent, "title", "")
          : _.get(parent, "title");

        const item = {
          id: _.get(calendarItem, "parent.id"),
          title: calendarTitle,
          totalUserCount: _.size(assignedUsersFromThisCalendar),
          assignedUsers: assignedUsersFromThisCalendar,
        };

        result.push(item);
      }
      return result;
    },
    []
  );
};

/////
///

////

///

////

///

///

const getDialogsInfo = ({ isVideoMeeting, t, eventHeaderTitle }) => {
  const confirmationMessage = isVideoMeeting
    ? t("calendar:delete_confirmation_message_with_label", {
        label: _.lowerCase(t("common:meeting")),
      })
    : t("calendar:delete_confirmation_message_with_label", {
        label: _.lowerCase(t(eventHeaderTitle)),
      });
  const dialogsInfo = {
    DELETE: {
      title: isVideoMeeting
        ? t("calendar:delete_meeting")
        : t("calendar:delete_label", {
            label: _.lowerCase(t(eventHeaderTitle)),
          }),
      message: confirmationMessage,
      confirmButtonText: t => t("common:delete"),
      cancelButtonText: t => t("common:cancel"),
    },
  };
  return dialogsInfo;
};

const EventModal = React.memo(props => {
  const {
    eventId,
    eventData,
    onCloseEventModal,
    deletePlatformCalendarEvent,
    userType,
    deleteAssignment,
    setToastMsg,
    userId,
    goToRelativeRoute,
    openLinkInNewTab,
    goToPlatformHomeChildRoute,
    accessedViaDailyView,
    t,
    updatePlatformCalendarEventBasicDetails,
    quickUpdateAssignmentScheduleAndDueTime,
    userCourses,
    showCalendarAssignmentByDueDate,
    selectedViewOnlyTags,
    currentCurriculumProgramType,
    currentCurriculumProgramId,
    getIsCurrentAcademicYear,
    courseId: currentCourse,
    isCalendarDeadlineView,
    defaultStudentNameOrderPreference,
    isParent,
    childId,
    academicYearStartDate,
    academicYearEndDate,
    testId,
    eventsRef,
    courseList = [],
    isUserStaff,
    isStudentProfileCalendarView,
    organizationId,
    academicYearId,
    organizationCurriculumPrograms,
    isStaffSchoolCalendarAdmin,
    rnpRoleContextDetail,
    updateEventModalV2,
    editVideoMeeting,
    associatedEntities: associatedEntitiesFromEnhancer,
    // In case of custom participant getCalendarEventAssociatedEntitiesEnhancer query get skip
    // above query return the participantListType but when it's skip it's value is undefined (breaking custom participant vm update flow )
    // so we are defaulting it to "CUSTOM" type in case of undefined value
    participantListType = ENTITY_TYPE_MAPPING.CUSTOM,
    isVideoMeetingRevampEnabled,

    // loading states
    isAssociatedEntitiesDetailsLoading,
    isEventDetailsLoading: isMeetingDetailsLoading,
    networkStatus,
  } = props;

  /*
    EventModal component can be used independently outside MyCalendar component.
    Hence, we need to ensure that the refetchEvents & refetchAssignedData function is available either
    from props or we create a default one here to refetch the calendar events query 
    when the master calendar in in the background.
    */
  const client = useApolloClient();
  const refetchEvents =
    props?.refetchEvents ||
    getRefetchFunctionForQuery({ client, query: getCalendarEventsDataQuery });
  const refetchAssignedData =
    props?.refetchAssignedData ||
    getRefetchFunctionForQuery({
      client,
      query: getCalendarEventsParticipantDataQuery,
    });

  const [isLoading, setIsLoading] = useState(false);
  const [currentDialogAction, setCurrentDialogAction] = useState("");
  const [currentDialogItem, setCurrentDialogItem] = useState({});
  const [isEditingEvent, setIsEditingEvent] = useState(false);
  const [editModeDetails, setEditModeDetails] = useState({});
  const eventDetails = getNormalizedEventDetails({
    eventData,
    userId,
    userType,
    defaultStudentNameOrderPreference,
  });

  const [showRecurringDeleteOptions, setShowRecurringDeleteOptions] = useState(
    false
  );
  const [eventIdForDeletion, setEventIdForDeletion] = useState("");
  const {
    id,
    item,
    itemType,
    contentType,
    courseId,
    publishedTime,
    submissionDeadlineTime,
    scheduleDate,
    scheduleStartTime,
    scheduleEndTime,
    meetingLink,
    meetingType,
    meetingCode,
    meetingPasscode,
    createdBy,
    assignmentId,
    repeatEventSettings,
    calendarWiseAssignedUsers,
    calendars,
    state,
    publishedAt,
    calendarAssignmentEndAt,
    stringDeadline,
    submissionsSummaryCounts,
    closeSubmissionDate,
    visibility,
    isStudentSubmissionEnabled,
    isPrivate,
    currentStudentAssignmentId,
    isAssessmentLocked,
    recurrenceStart,
    startTime,
    metadata,
    eventReminders,
    meeting,
  } = eventDetails;

  const { users, sharedWith, attachments } = item;

  // The associatedEntities enhancer is skipped for non-staff users (e.g. parents),
  // so fall back to the event data's own associatedEntities.
  const associatedEntities = associatedEntitiesFromEnhancer
    ? associatedEntitiesFromEnhancer
    : _.get(item, "associatedEntities", []);

  const assignmentStatus = _.get(item, "state.state", null);

  const [isQuickReschedule, setIsQuickReschedule] = useState(false);
  const [recurringOption, setRecurringOption] = useState("ALL");
  const [rescheduleData, updateRescheduleData] = useState({
    // Following used for meetings
    scheduleDate,
    scheduleStartTime,
    scheduleEndTime,

    // Following used for Assignments
    publishedAt, //zulu time ISO string
    calendarAssignmentEndAt, //zulu time ISO string
    dueDate: stringDeadline, //zulu time ISO string
    closeSubmissionDate, //zulu time ISO string
  });
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const errorMsgLocalesRef = useRef(
    "classRoom:cannot_access_class_task_sentence_case"
  );

  const containerRef = useRef();

  // Tracks whether the user has edited reschedule fields. When true, an in-flight
  // detail-query result must not overwrite the user's in-progress edit.
  const isRescheduleDirtyRef = useRef(false);

  // Reset dirty flag when the modal switches to a different event.
  useEffect(() => {
    isRescheduleDirtyRef.current = false;
  }, [eventId]);

  // Re-sync rescheduleData whenever the server-supplied date surface for the
  // current event changes — keyed on a composite of all date fields the picker
  // consumes, including ones that are only populated after the detail query
  // resolves (publishedAt, closeSubmissionDate). Primitive-by-primitive deps were
  // unreliable: derived strings like scheduleDate could be content-equal across
  // list→detail transitions even when the underlying source changed.
  // networkStatus is included so the sync fires when the detail query completes
  // a network round-trip (cache-and-network: status 2→7), even when cached and
  // network values happen to be string-equal for some date fields.
  const rescheduleSyncKey = [
    eventId,
    networkStatus,
    startTime,
    calendarAssignmentEndAt,
    publishedAt,
    stringDeadline,
    closeSubmissionDate,
  ].join("|");

  useEffect(() => {
    if (isRescheduleDirtyRef.current) return;
    updateRescheduleData({
      scheduleDate,
      scheduleStartTime,
      scheduleEndTime,
      publishedAt,
      calendarAssignmentEndAt,
      dueDate: stringDeadline,
      closeSubmissionDate,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- rescheduleSyncKey is an intentional composite key; individual primitive deps were content-equal across cache→network transitions so the sync effect wouldn't re-fire reliably
  }, [rescheduleSyncKey]);

  useEffect(() => {
    containerRef?.current?.focus();
  }, []);

  const isVideoMeeting = getIsVideoMeeting(item, itemType);
  const isVideoMeetingAndRevampEnabled =
    isVideoMeeting && isVideoMeetingRevampEnabled;

  const isNewCalendarEnabled = isMasterCalendarV1Enabled({
    currentCurriculumProgramType,
  });

  const isCalendarAssignmentAssignFlowRevampEnabled = getIsCalendarAssignmentAssignFlowRevampEnabled();
  const { filteredAssessmentTypes } = useAssessmentTags();
  const {
    title,
    description,
    backgroundColor,
    color,
    eventIcon,
    headerTitle,
    assessmentValue,
  } = getEventMetadata({
    item,
    itemType,
    userType,
    calendars,
    isNewCalendarEnabled,
    currentCurriculumProgramId,
  });

  const isGradingPeriodUnlocked = getIsGradingPeriodUnlocked(
    _.get(item, "content.academicTerm")
  );

  const isViewOnlyTag = isViewOnlyTagMemoize({
    selectedViewOnlyTags,
    itemType,
    isCalendarDeadlineView,
  });

  const escapePress = e => {
    const code = e.keyCode ? e.keyCode : e.which;
    if (code == 27) {
      e.stopPropagation();
      onCloseEventModal();
      onToggleDialogueClick();
      if (eventsRef) {
        const id = _.get(eventData, "item.id");
        if (eventsRef.current[id]?.parentElement?.parentElement) {
          eventsRef.current[id]?.parentElement?.parentElement?.focus();
        } else {
          eventsRef.current[id]?.focus();
        }
      }
    }
  };

  // this is required to preserve reference of escapePress
  // so that we can remove the event listener on component unmount or when edit button press
  // (which opens the edit event form and we don't want this escape key function to work when the edit form is open,
  //  as the edit form will have its own escape key handling)
  const escapeFuncRef = useRef(escapePress);

  useEffect(() => {
    document.addEventListener("keydown", escapeFuncRef.current, true);
    const escFuncRef = escapeFuncRef.current;
    return () => {
      document.removeEventListener("keydown", escFuncRef, true);
    };
  }, []);

  const _refetchEvents = () => {
    if (refetchEvents) {
      refetchEvents();
    }
  };

  // 2DPLATTODO-calendar: Need to refactor this to a more generic function name so the responsibility is clear
  const onRecurringOptionsDelete = async option => {
    if (isVideoMeetingAndRevampEnabled) {
      /**
       * Here we are handling both edit and delete action for revamped video meeting
       */

      // Set the recurring option and close the reccuring options modal
      setRecurringOption(option);
      setShowRecurringDeleteOptions(false);

      // Open the delete/edit confirmation notify dialog
      // 2DPLATTODO-calendar: Need to update this to a more generic stateSetter
      setEventIdForDeletion(eventId);

      if (!_.isEqual(currentDialogAction, "EDIT")) {
        setCurrentDialogAction("DELETE");
      }
    } else {
      deletePlatformCalendarEvent({
        id: eventId,
        actionFor: option,
        refetchEvents: _refetchEvents,
        refetchAssignedData,
        setShowRecurringDeleteOptions,
        onCloseEventModal,
      });
    }
  };

  const onClickDelete = async () => {
    setCurrentDialogItem({ id: assignmentId });
    if (itemType === "CALENDAR_EVENT_ITEM") {
      if (repeatEventSettings) {
        setShowRecurringDeleteOptions(true);
      } else {
        setEventIdForDeletion(eventId);
        setCurrentDialogAction("DELETE");
      }
    } else {
      setCurrentDialogAction("DELETE");
    }
  };

  const isAssignment = itemType === MY_CALENDAR_CONSTANTS.ASSIGNMENT;

  const allowAssignmentScheduleEndTimeChange = ACLStore.can(
    "Common:AllowScheduleEndTimeChangeOnCalendar"
  );

  const onClickUpdate = () => {
    if (isQuickReschedule) {
      // Handle update meeting
      if (isVideoMeetingAndRevampEnabled) {
        setCurrentDialogAction("EDIT");
        // Show recurring settings only if its a recurring meeting, this option will handle to show Notify and Message dialog as well
        setShowRecurringDeleteOptions(!_.isEmpty(repeatEventSettings));
        // Show Notify and Message dialog directly when it's not a recurring meeting
        if (_.isEmpty(repeatEventSettings)) {
          setEventIdForDeletion(eventId);
        }
      } else {
        onConfirmBtnClick();
      }
    } else {
      // Handle join meeting
      openLinkInNewTab({ url: meetingLink });
    }
  };

  const onConfirmBtnClick = async () => {
    //reschedule event from quick view
    if (isQuickReschedule) {
      setIsLoading(true);
      let isSuccess = false;

      if (isAssignment) {
        const { isValid, message } = validateAssignmentDateSequence({
          publishedAt: _.get(rescheduleData, "publishedAt"),
          dueDate: _.get(rescheduleData, "dueDate"),
          closeSubmissionDate: _.get(rescheduleData, "closeSubmissionDate"),
        });

        if (!isValid) {
          setToastMsg(t(message));
          setIsLoading(false);
          return;
        }

        isSuccess = await quickUpdateAssignmentScheduleAndDueTime({
          id,
          courseId,
          itemType,
          publishedAt: _.get(rescheduleData, "publishedAt"),
          calendarAssignmentEndAt: _.get(
            rescheduleData,
            "calendarAssignmentEndAt"
          ),
          dueDate: _.get(rescheduleData, "dueDate"),
          setIsQuickReschedule,
          closeSubmissionDate: _.get(rescheduleData, "closeSubmissionDate"),
        });
      } else {
        isSuccess = await updatePlatformCalendarEventBasicDetails({
          id,
          itemType,
          rescheduleData,
          setIsQuickReschedule,
        });
      }

      if (isSuccess) {
        _refetchEvents();
        setToastMsg({
          msg: "toastMsgs:event_update_success",
          type: "success",
        });
        onCloseEventModal();
      } else {
        setToastMsg("toastMsgs:something_went_wrong");
      }
      setIsLoading(false);
      return;
    }

    if (meetingLink) {
      openLinkInNewTab({ url: meetingLink });
    } else {
      if (isStudentProfileCalendarView) {
        goToPlatformHomeChildRoute({
          route: `links/classroom-details/${assignmentId}/mediamanager/${currentStudentAssignmentId}`,
          isOpenInNewTab: true,
        });
      } else if (accessedViaDailyView) {
        goToPlatformHomeChildRoute({
          route: `links/classroom-details/${assignmentId}/`,
          isOpenInNewTab: true,
        });
      } else {
        if (isViewOnlyTag) {
          if (!_.isEmpty(currentCourse)) {
            goToRelativeRoute({
              route: `./classroom-details/${assignmentId}/`,
              replacePath: `${currentCourse}`,
            });
          } else {
            goToRelativeRoute({
              route: `./courses/classroom-details/${assignmentId}/`,
              replacePath: "project-group-types",
            });
          }
        } else {
          goToPlatformHomeChildRoute({
            route: `links/classroom-details/${assignmentId}/`,
            isOpenInNewTab: true,
          });
        }
      }
    }
  };

  const onToggleDialogueClick = () => {
    setCurrentDialogAction("");
    setCurrentDialogItem({});
  };

  const onDeleteDialogueClose = () => {
    setEventIdForDeletion("");
    setCurrentDialogAction("");
  };

  const onConfirmDeleteEventClick = props => {
    const { sendMessage = false, message = "" } = props || {};
    deletePlatformCalendarEvent({
      id: eventId,
      actionFor: recurringOption,
      refetchEvents: _refetchEvents,
      refetchAssignedData,
      setShowRecurringDeleteOptions,
      onCloseEventModal,
      message,
      sendMessage,
    });
  };

  const onConfirmUpdateEventClick = async props => {
    const { sendMessage = false, message = "" } = props || {};
    await quickUpdateRevampedVideoMeeting({
      repeatEventSettings,
      startTime,
      recurrenceStart,
      rescheduleData,
      id,
      meeting,
      title,
      description,
      message,
      sendMessage,
      eventDetails,
      eventReminders,
      sharedWith,
      participantListType,
      metadata,
      recurringOption,
      _refetchEvents,
      refetchAssignedData,
      setShowRecurringDeleteOptions,
      onCloseEventModal,
      editVideoMeeting,
    });
  };

  const onDialogConfirmClick = async () => {
    const { id } = currentDialogItem;

    switch (currentDialogAction) {
      case "DELETE":
        setIsLoading(true);
        try {
          await deleteAssignment(id);
          setToastMsg({
            msg: "toastMsgs:action_successfully",
            locale_params: [
              {
                key: "label",
                value: "common:post",
                isPlainText: false,
              },
              { key: "action", value: "toastMsgs:delete", isPlainText: false },
            ],
            type: "success",
          });
        } catch (e) {
          if (e.networkError) {
            setToastMsg("toastMsgs:no_internet_connection");
          } else {
            setToastMsg("toastMsgs:something_went_wrong");
          }
        } finally {
          setIsLoading(false);
          onCloseEventModal();
          _refetchEvents();
        }
        break;
    }
  };

  const onClickEdit = () => {
    document.removeEventListener("keydown", escapeFuncRef.current, true);
    setIsEditingEvent(true);
    setEditModeDetails({
      id: assignmentId,
      eventId: id,
      contentType,
      itemType,
      item,
    });

    const transformedMeetingData = getTransformedVideoMeetingDataFromQuery(
      eventData
    );
    updateEventModalV2(transformedMeetingData);
  };

  const onRescheduleEventClick = param => {
    setIsQuickReschedule(param);
  };

  const [isScheduleDateChanged, setIsScheduleDateChanged] = useState(false);

  const rescheduleDataChangesLocal = params => {
    const { scheduleDate: newScheduleDate } = params;
    if (scheduleDate !== newScheduleDate && !_.isEmpty(newScheduleDate)) {
      setIsScheduleDateChanged(true);
    } else {
      setIsScheduleDateChanged(false);
    }
    isRescheduleDirtyRef.current = true;
    updateRescheduleData({ ...rescheduleData, ...params });
  };

  const courseIds = _.map(_.filter(calendars, { parentType: "COURSE" }), item =>
    _.get(item, "parent.id")
  );

  const isNotUserCourse = _.isEmpty(_.intersection(userCourses, courseIds));
  const isUserCourse = !isNotUserCourse;

  const isCurrentAcademicYear = getIsCurrentAcademicYear();

  const isEventCreatedByTheCurrentUser =
    _.get(createdBy, "id", null) === userId;

  const creatorName = getFormattedUserName({
    user: createdBy,
    type: "staff",
  });

  const filteredCourses = getFilteredCoursesBasedOnViewOrManagePermission({
    courses: courseList,
    permissionsToCheck: [ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR],
  });
  const canManageAssignment =
    itemType === "ASSIGNMENT"
      ? !_.isEmpty(_.find(filteredCourses, { courseId }))
      : true;

  const isWorksheetWithFixedStartTime =
    _.get(item, "isFixedStartTime", false) &&
    _.isEqual(_.get(item, "content.assessmentType.value", ""), "worksheet");

  const {
    isLoading: isScopeCheckLoading,
    isVisible: isCalendarEventInUserScope,
  } = useIsCalendarInUserScope({
    isStaff: isUserStaff,
    userId,
    eventData,
    organizationId,
    academicYearId,
    currentCurriculumProgramId,
    isStaffSchoolCalendarAdmin,
    courseList,
    organizationCurriculumPrograms,
  });

  const canUserEditThisMeeting = () => {
    /**
     * Filter out common false cases where user cannot edit the meeting
     */
    // 1. If viewing from student profile do not allow to perform any actions
    if (isStudentProfileCalendarView) return false;
    // 2. If user is not staff, do not allow to perform any actions
    if (!isUserStaff) return false;
    // 3. If user is not in current academic year, do not allow to perform any actions
    if (!isCurrentAcademicYear) return false;

    if (isVideoMeetingAdminEditEnabled()) {
      const isRnpConsumptionAllowed = ACLStore.can(
        ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION
      );

      if (isRnpConsumptionAllowed) {
        // 4a. RnP org: super admins can always edit any video meeting
        const isSuperAdmin = _.some(rnpRoleContextDetail, detail =>
          _.isEqual(_.get(detail, "role.globalRole.uid"), "SUPER_ADMIN")
        );
        if (isSuperAdmin) return true;
      } else {
        // 4b. Non-RnP org: legacy admins can always edit any video meeting
        if (getIsAdminByRole()) return true;
      }

      // 5. The creator can edit only if they have access to all current participants
      return (
        isEventCreatedByTheCurrentUser &&
        !isScopeCheckLoading &&
        isCalendarEventInUserScope
      );
    }

    // 6. Flag off: only the creator can edit (original behaviour)
    return isEventCreatedByTheCurrentUser;
  };

  const eventHeaderTitle = isCalendarEventAssessmentEnabled(
    currentCurriculumProgramType
  )
    ? _.get(filteredAssessmentTypes, [assessmentValue, "typeLabel"], "")
    : headerTitle;

  const DIALOGS_INFO = getDialogsInfo({ isVideoMeeting, t, eventHeaderTitle });

  return (
    <>
      <div
        onClick={e => e?.stopPropagation()}
        // ref={wrapperRef}
        className={classes.container}
        ref={containerRef}
        tabIndex={-1}
      >
        <div className={classes.innerContainer}>
          <EventHeader
            userType={userType}
            itemType={itemType}
            hideEditButton={
              itemType === "ASSIGNMENT" && contentType === "ASSIGNMENT_MEETING"
            }
            isViewOnlyTag={isViewOnlyTag}
            onClickEdit={onClickEdit}
            onClickDelete={onClickDelete}
            onCloseEventModal={onCloseEventModal}
            isNotUserCourse={isNotUserCourse}
            backgroundColor={backgroundColor}
            headerTitle={eventHeaderTitle}
            isCurrentAcademicYear={isCurrentAcademicYear}
            isGradingPeriodUnlocked={isGradingPeriodUnlocked}
            testId={`${testId}-eventHeader`}
            canManageAssignment={canManageAssignment}
            isAssessmentLocked={isAssessmentLocked}
            isVideoMeeting={getIsVideoMeeting(item, itemType)}
            canUserEditThisMeeting={canUserEditThisMeeting}
            isVideoMeetingRevampEnabled={isVideoMeetingAndRevampEnabled}
            isMeetingDetailsLoading={
              isMeetingDetailsLoading || isAssociatedEntitiesDetailsLoading
            }
          />
          {/* 2DPLATTODO-calendar: Have to simplify props passed to EventBody */}
          <EventBody
            color={color}
            title={title}
            eventIcon={eventIcon}
            description={description}
            meetingLink={meetingLink}
            meetingType={meetingType}
            meetingCode={meetingCode}
            meetingPasscode={meetingPasscode}
            publishedTime={publishedTime}
            deadline={_.get(item, "stringDeadline")}
            assignmentState={_.get(item, "state")}
            submissionDeadlineTime={submissionDeadlineTime}
            scheduleDate={scheduleDate}
            scheduleStartTime={scheduleStartTime}
            scheduleEndTime={scheduleEndTime}
            backgroundColor={backgroundColor}
            calendarWiseAssignedUsers={calendarWiseAssignedUsers}
            onRescheduleEventClick={onRescheduleEventClick}
            rescheduleDataChangesLocal={rescheduleDataChangesLocal}
            rescheduleData={rescheduleData}
            setFooterDisabled={setIsButtonDisabled}
            userId={userId}
            userType={userType}
            itemType={itemType}
            errorMsgLocalesRef={errorMsgLocalesRef}
            t={t}
            isVideoMeeting={getIsVideoMeeting(item, itemType)}
            isNotUserCourse={isNotUserCourse}
            isUserCourse={isUserCourse}
            showCalendarAssignmentByDueDate={showCalendarAssignmentByDueDate}
            isCurrentAcademicYear={isCurrentAcademicYear}
            isViewOnlyTag={true}
            state={state}
            isParent={isParent}
            childId={childId}
            calendars={calendars}
            academicYearStartDate={academicYearStartDate}
            academicYearEndDate={academicYearEndDate}
            isGradingPeriodUnlocked={isGradingPeriodUnlocked}
            testId={`${testId}-eventBody`}
            allowAssignmentScheduleEndTimeChange={
              allowAssignmentScheduleEndTimeChange
            }
            canManageAssignment={canManageAssignment}
            submissionsSummaryCounts={submissionsSummaryCounts}
            visibility={visibility}
            isCalendarAssignmentAssignFlowRevampEnabled={
              isCalendarAssignmentAssignFlowRevampEnabled
            }
            currentCurriculumProgramId={currentCurriculumProgramId}
            isWorksheetWithFixedStartTime={isWorksheetWithFixedStartTime}
            isStudentProfileCalendarView={isStudentProfileCalendarView}
            isStudentSubmissionEnabled={isStudentSubmissionEnabled}
            isPrivate={isPrivate}
            summaryCounts={_.get(item, "summaryCounts", {})}
            associatedEntities={associatedEntities}
            participantListType={participantListType}
            isAssociatedEntitiesDetailsLoading={
              isAssociatedEntitiesDetailsLoading
            }
            users={users}
            sharedWith={sharedWith}
            attachments={attachments}
            repeatEventSettings={repeatEventSettings}
            recurrenceStart={recurrenceStart}
            startTime={startTime}
            metadata={metadata}
            canUserEditThisMeeting={canUserEditThisMeeting}
            isMeetingDetailsLoading={
              isMeetingDetailsLoading || isAssociatedEntitiesDetailsLoading
            }
          />
          <EventFooter
            createdBy={createdBy}
            errorMsgLocalesRef={errorMsgLocalesRef}
            onConfirmBtnClick={
              isVideoMeetingAndRevampEnabled ? onClickUpdate : onConfirmBtnClick
            }
            isQuickReschedule={isQuickReschedule}
            itemType={itemType}
            isButtonDisabled={isButtonDisabled}
            isNotUserCourse={isNotUserCourse}
            isParent={isParent}
            sharedWith={sharedWith}
            associatedEntities={associatedEntities}
            users={users}
            canJoin={
              !isParent ||
              itemType !== MY_CALENDAR_CONSTANTS.CALENDAR_EVENT_ITEM
            }
            t={t}
            testId={`${testId}-eventFooter`}
            isCurrentAcademicYear={isCurrentAcademicYear}
            isUserStaff={isUserStaff}
            assignmentStatus={assignmentStatus}
            isVideoMeeting={getIsVideoMeeting(item, itemType)}
            isVideoMeetingRevampEnabled={isVideoMeetingAndRevampEnabled}
            meetingLink={meetingLink}
          />
        </div>
      </div>
      {isEditingEvent && (
        <EditOrCreateEvent
          mode={"edit"}
          courseId={courseId} //  for video meetings courseId will be sent null. becoz there can be multiple courses in on event
          calendarEventModalClose={onCloseEventModal}
          editModeDetails={editModeDetails}
          refetchEvents={_refetchEvents}
          testId={`${testId}-editOrCreateEvent`}
        />
      )}
      {!!currentDialogAction &&
      !eventIdForDeletion &&
      !isVideoMeetingAndRevampEnabled ? (
        <Dialog
          isOpen={true}
          title={DIALOGS_INFO[currentDialogAction]?.title}
          message={DIALOGS_INFO[currentDialogAction]?.message}
          buttonOneText={
            DIALOGS_INFO[currentDialogAction]?.cancelButtonText(t) ||
            t("common:cancel")
          }
          buttonTwoText={DIALOGS_INFO[currentDialogAction]?.confirmButtonText(
            t
          )}
          onButtonOneClick={onToggleDialogueClick}
          onButtonTwoClick={onDialogConfirmClick}
          onClose={onToggleDialogueClick}
          dsVersion={"2.0"}
        />
      ) : null}
      {eventIdForDeletion && !isVideoMeetingAndRevampEnabled ? (
        <Dialog
          isOpen={!_.isEmpty(eventIdForDeletion)}
          title={DIALOGS_INFO[currentDialogAction]?.title}
          message={DIALOGS_INFO[currentDialogAction]?.message}
          buttonOneText={
            DIALOGS_INFO[currentDialogAction]?.cancelButtonText(t) ||
            t("common:cancel")
          }
          buttonTwoText={DIALOGS_INFO[currentDialogAction]?.confirmButtonText(
            t
          )}
          onButtonOneClick={onDeleteDialogueClose}
          onButtonTwoClick={onConfirmDeleteEventClick}
          onClose={onDeleteDialogueClose}
          dsVersion={"2.0"}
        />
      ) : null}
      {/* Update/Delete Notify and Message Modal */}
      {isVideoMeetingAndRevampEnabled && !_.isEmpty(eventIdForDeletion) ? (
        <DSProvider dsVersion="2.0">
          <EventUpdateConfirmationModal
            isOpen={!_.isEmpty(eventIdForDeletion)}
            onConfirm={
              _.isEqual(currentDialogAction, "EDIT")
                ? onConfirmUpdateEventClick
                : onConfirmDeleteEventClick
            }
            onClose={onDeleteDialogueClose}
            title={
              _.isEqual(currentDialogAction, "EDIT")
                ? "calendar:update_video_meeting"
                : "calendar:delete_meeting"
            }
            checkboxLabel={
              _.isEqual(currentDialogAction, "EDIT")
                ? "calendar:notify_all_the_participants_about_the_update_of_this_meeting"
                : "calendar:notify_all_the_participants_about_the_deletion_of_this_meeting"
            }
            confirmationMessage={
              _.isEqual(currentDialogAction, "EDIT")
                ? "calendar:update_meeting_confirmation_message"
                : "calendar:delete_meeting_confirmation_message"
            }
            saveButtonLabel={
              _.isEqual(currentDialogAction, "EDIT")
                ? "common:update"
                : "common:delete"
            }
            cancelButtonLabel="common:cancel"
            height="max-content"
            messagePlaceholder="calendar:add_optional_message"
          />
        </DSProvider>
      ) : null}
      {/* Recurrence Update/Delete type select */}
      {showRecurringDeleteOptions ? (
        <ActionForSelectModal
          t={t}
          onClose={setShowRecurringDeleteOptions}
          onAction={onRecurringOptionsDelete}
          confirmButtonText={
            // Since in revamped recurring video meeting, we show a option to send notification message as next step
            isVideoMeetingAndRevampEnabled && !_.isEmpty(repeatEventSettings)
              ? t("common:continue")
              : null
          }
          mode={_.isEqual(currentDialogAction, "EDIT") ? "edit" : "delete"}
          testId={testId}
          isScheduleDateChanged={isScheduleDateChanged}
        />
      ) : null}
      {isLoading && <FullScreenLoader />}
    </>
  );
});

EventModal.displayName = "EventModal";

const EventModalWithLoading = withLoader(EventModal);

const EventModalComp = props => {
  const isInMobile = _.get(props, "isInMobile", false);
  const { itemType } = props || {};
  const isAssignment = itemType === MY_CALENDAR_CONSTANTS.ASSIGNMENT;
  const LoadingComponent = isAssignment
    ? EventAssignmentLoader
    : EventModalLoader;
  const isEventDetailsLoading = !_.get(props, "isData", true); // when data is false, it means cache is empty it's initial loading
  const eventData = _.get(props, "eventData", {});
  if (isInMobile) {
    return <EventModalWithLoading {...props} />;
  }
  return (
    <div className={classes.modalContent}>
      {isEventDetailsLoading && _.isEmpty(eventData) ? (
        <LoadingComponent />
      ) : (
        <EventModalWithLoading {...props} />
      )}
    </div>
  );
};

const mapActionCreators = {
  deleteAssignment,
  setToastMsg,
  deletePlatformCalendarEvent,
  goToRelativeRoute,
  openLinkInNewTab,
  goToPlatformHomeChildRoute,
  updatePlatformCalendarEventBasicDetails,
  quickUpdateAssignmentScheduleAndDueTime,
  getIsCurrentAcademicYear,
  updateEventModalV2,
  editVideoMeeting,
};

const mapStateToProps = (state, ownProps) => {
  const {
    isStudentProfileCalendarView,
    studentProfileId,
    rnpRoleContextDetail,
  } = _.get(state, "myCalendar", {});

  const userInfo = _.get(state, "login.userInfo", {});
  const userEntityType = isStudentProfileCalendarView
    ? "STUDENT"
    : userInfo?.userEntityType;
  const userType = isStudentProfileCalendarView
    ? "student"
    : _.get(userInfo, "user_type");
  const userId = isStudentProfileCalendarView
    ? studentProfileId
    : _.get(userInfo, "id");
  const orgId = getOrganizationId(state);
  const isParent = getIsParent(state);
  const childId = getChildId(state);
  const platform = _.get(state, "platform", {});
  const isCurriculumProgramFree = getCurriculumProgramFreeStatus({ state });
  const {
    currentCurriculumProgramId,
    currentCurriculumProgramType,
  } = getSelectedSchoolDetailsForCalendar(state);
  const defaultStudentNameOrderPreference = getDefaultStudentNameOrderPreference(
    state
  );

  const isUserStaff =
    isUserTypeStaff({ userType }) && !isStudentProfileCalendarView;

  const showCalendarAssignmentByDueDate =
    getCalendarEventsViewSettingValue({
      organizationId: userInfo.org_id,
      currentCurriculumProgramId,
    }) === MY_CALENDAR_CONSTANTS.DUE_DATE;

  const courseId = _.get(ownProps.params, "course_id", undefined);
  const academicYearId = getSelectedAcademicYearIdForSchool(state);
  const courseGradeFilters = getCourseGradeFiltersMemoized({ academicYearId });
  const organizationCurriculumPrograms = _.get(
    state,
    "platform.organizationCurriculumPrograms",
    []
  );
  const academicYearSelected = getSelectedAcademicYearForSchool(state);

  const courseFilters = getCourseFiltersMemoized({
    courseId,
    courseGradeFilters,
    currentCurriculumProgramType,
    organizationCurriculumPrograms,
    currentCurriculumProgramId,
    academicYearSelected,
  });

  const calendarView = _.get(state, "myCalendar.calendarView");
  const isAgendaView = _.isEqual(calendarView, "agenda", true);

  return {
    userId,
    userEntityType,
    selectedChildId: childId,
    isUserParent: isParent,
    entityType: "PLATFORM_CALENDAR_EVENT",
    isData: true,
    isLoading: false,
    userType,
    courseFilters,
    showCalendarAssignmentByDueDate,
    calendarIds: _.get(state, "myCalendar.fullscreenView.calendarIds", []),
    selectedViewOnlyTags: _.get(state, "myCalendar.selectedViewOnlyTags", []),
    currentCurriculumProgramType: getCurrentCurriculumProgramType(state),
    currentCurriculumProgramId,
    defaultStudentNameOrderPreference,
    isParent,
    childId,
    academicYearEndDate: getAcademicYearEndDate({ organizationId: orgId }),
    academicYearStartDate: getAcademicYearStartDate({ organizationId: orgId }),
    isUserStaff,
    isStudentProfileCalendarView,
    studentProfileId,
    organizationId: orgId,
    isVideoMeetingRevampEnabled: isNewVideoMeetingUIFeatureEnabled(),
    academicYearId,
    organizationCurriculumPrograms,
    isStaffSchoolCalendarAdmin:
      !isStudentProfileCalendarView &&
      isStaffAdminForSchoolCalendarByContext({
        contexts: [
          {
            entityId: currentCurriculumProgramId,
            entityType: "CURRICULUM_PROGRAM",
          },
        ],
      }),
    rnpRoleContextDetail,
    isAgendaView,
    isStaffUser: isUserTypeStaff({ userType }),
  };
};

export default compose(
  I18nHOC({
    resource: ["common", "toastMsgs", "calendar", "classRoom"],
  }),
  connect(mapStateToProps, mapActionCreators),
  graphql(getCourseCalendarDetailsQuery, {
    name: "getCourseCalendarDetails",
    options: ({
      isParent,
      userId,
      userEntityType,
      courseFilters,
      childId,
      userType,
    }) => ({
      fetchPolicy: CACHE_AND_NETWORK,
      variables: {
        id: isParent ? childId : userId,
        type: isParent ? STUDENT_USER : userEntityType,
        filters: courseFilters,
        enabledModulesFilters: {
          moduleNames: ["CLASS_STREAM", "CLASS_FLOW"],
          userType,
        },
        aclControlParameterFilter:
          ACLStore.can(ENABLE_ROLES_AND_PERMISSIONS_CONSUMPTION) &&
          userType === "staff"
            ? {
                controlParameters: ASSIGNMENTS_MANAGE_PERMISSION_IN_CALENDAR,
              }
            : undefined,
      },
    }),
    props({
      getCourseCalendarDetails,
      ownProps: { isData, isLoading, userType },
    }) {
      const queryData = _.get(getCourseCalendarDetails, "node", {});

      const allCourses =
        userType !== "staff"
          ? _.get(queryData, "courses", [])
          : _.map(
              //Since we are using different query type for staff
              _.get(queryData, "coursesV2.edges", []),
              courseEdge => courseEdge?.node
            );

      const courses = removeDemoCoursesMemoized({ allCourses });

      const userCourses = _.map(courses, ({ id }) => id);

      return {
        isData: !_.isEmpty(queryData) && isData,
        userCourses,
        isLoading:
          getCourseCalendarDetails["networkStatus"] == 1 ||
          getCourseCalendarDetails["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  getCalendarEventDetailsEnhancer(),
  getCalendarEventAssociatedEntitiesEnhancer()
)(EventModalComp);
